const routes = [];
let notFoundHandler = null;
let guard = null;

export function route(pattern, handler) {
  const segments = pattern.split('/').filter(Boolean);
  const paramNames = [];
  const regexParts = segments.map((seg) => {
    if (seg.startsWith(':')) {
      paramNames.push(seg.slice(1));
      return '([^/]+)';
    }
    return seg.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  });
  const regex = new RegExp(`^/${regexParts.join('/')}/?$`);
  routes.push({ pattern, regex, paramNames, handler });
}

export function setNotFound(handler) {
  notFoundHandler = handler;
}

export function setGuard(fn) {
  guard = fn;
}

export function navigate(path) {
  history.pushState({}, '', path);
  resolve();
}

export function currentPath() {
  return window.location.pathname;
}

function match(pathname) {
  for (const r of routes) {
    const m = pathname.match(r.regex);
    if (m) {
      const params = {};
      r.paramNames.forEach((name, i) => { params[name] = decodeURIComponent(m[i + 1]); });
      return { handler: r.handler, params };
    }
  }
  return null;
}

export function resolve() {
  const url = new URL(window.location.href);
  const pathname = url.pathname;
  const query = Object.fromEntries(url.searchParams);

  if (guard) {
    const redirect = guard(pathname);
    if (redirect && redirect !== pathname) {
      history.replaceState({}, '', redirect);
      return resolve();
    }
  }

  const matched = match(pathname);
  if (matched) {
    matched.handler({ pathname, query, params: matched.params });
  } else if (notFoundHandler) {
    notFoundHandler({ pathname, query });
  }
}

export function mountRouter() {
  window.addEventListener('popstate', resolve);
  document.addEventListener('click', (e) => {
    const link = e.target.closest('a[data-link]');
    if (!link) return;
    const href = link.getAttribute('href');
    if (!href || href.startsWith('http') || href.startsWith('#')) return;
    e.preventDefault();
    navigate(href);
  });
}

export function startRouter() {
  mountRouter();
  resolve();
}
